import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "fs-15px fw-600"
}
const _hoisted_3 = ["src"]

import { computed } from 'vue'
import { generateGradientColor } from '../common/helpers/functions/color'

interface IOverlappingItem {
  image?: string
  text?: string
}

interface IProps {
  status?: boolean
  statusColor?: string
  size?: string
  image?: string
  text?: string
  textSize?: string
  overlapping?: boolean
  overlappingItems?: IOverlappingItem[]
  overlappingMax?: number
}

const overlappWidth = 8

export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KAvatar', inheritAttrs: false },
  __name: 'KAvatar',
  props: {
    status: { type: Boolean, default: false },
    statusColor: { default: 'success-100' },
    size: { default: '32px' },
    image: { default: '' },
    text: { default: '^^' },
    textSize: { default: '13px' },
    overlapping: { type: Boolean, default: false },
    overlappingItems: { default: () => [] },
    overlappingMax: { default: 3 }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v03ed2f7b": (_ctx.size)
}))



const props = __props

const bgColor = computed(() => handleGradientColor(props.text))
const maxOverlappingItems = computed(() => props.overlappingItems.slice(0, props.overlappingMax))

function handleGradientColor(text: string) {
  return generateGradientColor(text) || ['#111c31', '#1361D4']
}

return (_ctx: any,_cache: any) => {
  const _component_q_avatar = _resolveComponent("q-avatar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["k-avatar", [`k-avatar--size-${__props.size}`, { 'k-avatar--overlapped': __props.overlapping }]])
  }, [
    (!__props.overlapping)
      ? (_openBlock(), _createBlock(_component_q_avatar, _mergeProps({
          key: 0,
          size: __props.size,
          style: `background-image: linear-gradient(135deg, ${bgColor.value[0]}, ${bgColor.value[1]});`,
          "text-color": "white"
        }, _ctx.$attrs), {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              (__props.image)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "k-avatar__image full-width full-height",
                    src: __props.image,
                    alt: "Avatar image"
                  }, null, 8 /* PROPS */, _hoisted_1))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(["fw-500", [`fs-${__props.textSize}`]])
                  }, _toDisplayString(__props.text.substring(0, 1)), 3 /* TEXT, CLASS */))
            ]),
            (__props.status)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["k-avatar__status", [`bg-${__props.statusColor}`]])
                }, null, 2 /* CLASS */))
              : _createCommentVNode("v-if", true)
          ]),
          _: 3 /* FORWARDED */
        }, 16 /* FULL_PROPS */, ["size", "style"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createCommentVNode("Overlapping avatars"),
          _createElementVNode("div", {
            class: "flex",
            style: _normalizeStyle(`min-width: ${Number.parseInt(__props.size) * maxOverlappingItems.value.length - (maxOverlappingItems.value.length - 1) * overlappWidth}px`)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(maxOverlappingItems.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_q_avatar, _mergeProps({
                key: index,
                size: __props.size,
                color: "mariner-100",
                "text-color": "white",
                class: "k-avatar--overlapping",
                style: `left: calc(${index} * (${__props.size} - ${overlappWidth}px)); background-image: linear-gradient(135deg, ${handleGradientColor(item.text || '').join(', ')})`
              }, { ref_for: true }, _ctx.$attrs), {
                default: _withCtx(() => [
                  (index === __props.overlappingMax - 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, " +" + _toDisplayString(__props.overlappingItems.length - __props.overlappingMax + 1), 1 /* TEXT */))
                    : (item.image)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          class: "full-width full-height",
                          src: item.image,
                          alt: "Avatar image"
                        }, null, 8 /* PROPS */, _hoisted_3))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: _normalizeClass(["fw-500", [`fs-${__props.textSize}`]])
                        }, _toDisplayString(item.text?.substring(0, 1)), 3 /* TEXT, CLASS */))
                ]),
                _: 2 /* DYNAMIC */
              }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["size", "style"]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 4 /* STYLE */)
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
  ], 2 /* CLASS */))
}
}

})